import { SortDescriptor } from '@progress/kendo-data-query';
import { isNullOrUndefined } from 'shared/utils/type.utils';

export const mapSortDescriptorsToQueryParam = (sortBy: SortDescriptor[]) => {
  if (isNullOrUndefined(sortBy)) return null;
  return sortBy.map(sortDesc => `${sortDesc.field}+${sortDesc.dir}`).join('|');
};
